// Composite skeleton stitching the three widget skeletons together. Pages
// can compose widgets directly per the FSD layer graph, so we delegate to
// each widget's own skeleton instead of duplicating the per-section markup.

import { ActivityHeatmapSkeleton } from "@widgets/activity-heatmap";
import { OptimalSlotsPanelSkeleton } from "@widgets/optimal-slots";
import { TopPostsBoardSkeleton } from "@widgets/top-posts";

export interface ContentSkeletonProps {
  loadingLabel?: string;
}

export function ContentSkeleton({ loadingLabel }: ContentSkeletonProps) {
  return (
    <div
      aria-busy="true"
      aria-label={loadingLabel}
      className="flex flex-col gap-6"
    >
      <ActivityHeatmapSkeleton />
      <TopPostsBoardSkeleton />
      <OptimalSlotsPanelSkeleton />
    </div>
  );
}
